export default __webpack_public_path__ + "static/media/logo_maven_ecoa_text_blue.93b67a45.png";